import { render, staticRenderFns } from "./PatientFaceSheetByAdmissionRep.vue?vue&type=template&id=1ffd62f9&"
import script from "./PatientFaceSheetByAdmissionRep.vue?vue&type=script&lang=js&"
export * from "./PatientFaceSheetByAdmissionRep.vue?vue&type=script&lang=js&"
import style0 from "./PatientFaceSheetByAdmissionRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports